commonModule.factory('errorMessageLookupService', ['providerFeaturesService','AppSettings','$q',
    function (providerFeaturesService, AppSettings, $q) {
        var errorMessageLookupService = {};
        var cachedMessages = {notRetrieved : true};
        var defaultMessages ={
            NotAuthenticated : "We're sorry, we didn't recognize that username and password combination. Please try again.",
            Global_Unknown : "It looks like you encountered an error we'll need to look into.  In the meantime, we'd advise you try that action again or try logging out and back in."
        };
        var unknownCode = 'Global_Unknown';

        errorMessageLookupService.lookupErrorMessage = function(messageCode){
            var deferred = $q.defer();
            if (cachedMessages.hasOwnProperty('notRetrieved')){
                try {
                    providerFeaturesService.getProviderApplicationSetting('UI-Error-Messages', null)
                        .then(
                            function successAppSetting(settingValue){
                                cachedMessages = JSON.parse(settingValue);
                                deferred.resolve(findErrMessage(messageCode));
                            },
                            function errorAppSetting(err){
                                deferred.resolve(findErrMessage(messageCode));
                            }
                        );
                }
                catch(err){
                    deferred.resolve(findErrMessage(messageCode));
                }
            }else {
                deferred.resolve(findErrMessage(messageCode));
            }

            return deferred.promise;
        }

        var findErrMessage = function(messageCode){
            if (cachedMessages.hasOwnProperty(messageCode)){
                return cachedMessages[messageCode];
            }else{
                if (defaultMessages.hasOwnProperty(messageCode))
                    return defaultMessages[messageCode];
                else if (cachedMessages.hasOwnProperty[unknownCode]){
                    return cachedMessages[unknownCode];
                }else{
                    return defaultMessages[unknownCode];
                }
            }
        }

        return errorMessageLookupService;
    }]);